'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4,
    _t5,
    _t6,
    _t7,
    _t8,
    _t9;

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H1 from 'UIComponents/elements/headings/H1';
import PhoneSupport from 'pricing-pages-unified-ui/components/common/PhoneSupport';
import UIFlex from 'UIComponents/layout/UIFlex';
import styled from 'styled-components';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
const StyledFlex = styled(UIFlex).withConfig({
  displayName: "PhoneSupportFooter__StyledFlex",
  componentId: "sc-1ygaojn-0"
})(["margin:140px auto 125px;", " ", " &.phone-support-footer{", "}.phone-support-footer__tel{width:350px;", " .phone-support-container{", " ", "}}.phone-heading{", "}*{z-index:1;}"], breakpoint.tablet(_t || (_t = _`
    justify-content: space-between;
    margin: 2.37em auto;
    position: relative;
  `)), breakpoint.phone(_t2 || (_t2 = _`
    margin: 3.5em auto 60px;
  `)), breakpoint.tabletPortrait(_t3 || (_t3 = _`
      display: block;
    `)), breakpoint.tablet(_t4 || (_t4 = _`
      width: auto;
    `)), breakpoint.tabletPortrait(_t5 || (_t5 = _`
        padding: 0;
        text-align: left;
      `)), breakpoint.phone(_t6 || (_t6 = _`
        margin-top: 2.5em;
      `)), breakpoint.tablet(_t7 || (_t7 = _`
      font-size: 1.5em;
      font-weight: 600;
    `)));
const StyledHeading = styled(H1).withConfig({
  displayName: "PhoneSupportFooter__StyledHeading",
  componentId: "sc-1ygaojn-1"
})(["width:70%;", " ", ""], breakpoint.tablet(_t8 || (_t8 = _`
    width: auto;
    line-height: 1.4;
  `)), breakpoint.phone(_t9 || (_t9 = _`
    line-height: 1.37;
    font-size: 2.18em;
  `)));

function PhoneSupportFooter({
  phoneSourceId,
  screen
}) {
  return /*#__PURE__*/_jsxs(StyledFlex, {
    grow: 2,
    className: "phone-support-footer",
    align: "center",
    justify: "center",
    children: [/*#__PURE__*/_jsx(StyledHeading, {
      "data-selenium-id": "phone-support-footer-header",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.crm.stillHaveQuestions"
      })
    }), /*#__PURE__*/_jsx("div", {
      grow: 1,
      className: "phone-support-footer__tel",
      children: /*#__PURE__*/_jsx(PhoneSupport, {
        screen: screen,
        className: "phone-support-footer__contents",
        phoneSourceId: phoneSourceId,
        showCopy: false,
        border: false
      })
    })]
  });
}

PhoneSupportFooter.propTypes = {
  phoneSourceId: PropTypes.string.isRequired,
  screen: PropTypes.string.isRequired
};
export default PhoneSupportFooter;